import { AccountSurveyActionResponse } from "~/entities/actions/types";
import {
  CHARITY_CHARITY_ANSWER_ID,
  CHARITY_DONATION_ANSWER_ID,
  CHARITY_NON_PROFIT_ANSWER_ID,
  CHARITY_QUESTION_ID,
} from "~/entities/survey/constants";
import useCreateAccountWizard from "~/hooks/useCreateAccountWizard";
import ErrorMessage from "./ErrorMessage";
import RadioField from "./RadioField";
import SubmitButton from "./SubmitButton";
import SurveyQuestion from "./SurveyQuestion";

type Props = {
  onSuccess: () => void;
  isActive: boolean;
};

const CharitySurvey: React.FC<Props> = ({ onSuccess, isActive }) => {
  const { errors, fetcher } =
    useCreateAccountWizard<AccountSurveyActionResponse>(onSuccess);

  if (!isActive) return null;

  return (
    <fetcher.Form
      method="post"
      action="/resources/create-account-wizard"
      className="flex flex-col gap-5"
      data-testid="charity-survey-form"
    >
      <input
        type="hidden"
        name="intent"
        value="charity_survey"
      />
      <h2 className="text-[20px] text-blue900 font-sans mt-0 uppercase font-bold">
        Do good. Look good. Feel good.
      </h2>

      <ErrorMessage error={errors["form"]} />

      <SurveyQuestion
        ordinal={1}
        question="Who are you?"
      >
        <RadioField
          id="non_profit"
          name={CHARITY_QUESTION_ID}
          value={CHARITY_NON_PROFIT_ANSWER_ID}
        >
          I am a non-profit
        </RadioField>
        <RadioField
          id="charity"
          name={CHARITY_QUESTION_ID}
          value={CHARITY_CHARITY_ANSWER_ID}
        >
          I work for or own a charity
        </RadioField>
        <RadioField
          id="donation"
          name={CHARITY_QUESTION_ID}
          value={CHARITY_DONATION_ANSWER_ID}
        >
          I&apos;m making a personal donation
        </RadioField>
      </SurveyQuestion>
      <SubmitButton
        disabled={fetcher.state === "submitting"}
        label="Almost done"
      />
    </fetcher.Form>
  );
};

export default CharitySurvey;
